"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMounted = void 0;

var _react = require("react");

var useMounted = function useMounted() {
  var mounted = (0, _react.useRef)(false);
  (0, _react.useEffect)(function () {
    mounted.current = true;
    return function () {
      mounted.current = false;
    };
  }, []);
  return mounted.current;
};

exports.useMounted = useMounted;


//////////////////
// WEBPACK FOOTER
// ./js/utils/hooks/useMounted.js
// module id = 396
// module chunks = 209 210 211 212